import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const els = document.querySelectorAll ('.uic-tool-reclami__root');

els.forEach (el => {
  const type = el.dataset.type ? el.dataset.type : 'form';
  const step = type === 'form' ? 3 : 2;
  const idAzienda = el.dataset.idAzienda
    ? parseInt (el.dataset.idAzienda)
    : false;

  const _params = new URLSearchParams (window.location.search);

  const isChatbot = _params.has ('cat');
  const campaign = _params.get ('utm_campaign');

  const isCategory = el.dataset.isCat ? parseInt (el.dataset.isCat) : 0;

  console.log ('type', type);

  ReactDOM.render (
    <React.StrictMode>
      <App
        type={type}
        step={step}
        idAzienda={idAzienda}
        isCategory={isCategory}
        isChatbot={isChatbot}
        campaign={campaign}
      />
    </React.StrictMode>,
    el
  );
});
